import { useEffect, useState } from "react";
import style from "./../../ClientBook.module.scss";
import Input from "../../UI/Input/Input";
import StepSkeleton from "../StepSkeleton";
import api from "helpers/api";

const PersonalDetails = ({ clinic, payload, show, number, complete, appointment }) => {
    const [ firstName, setFirstName ] = useState(null);
    const [ lastName, setLastName ] = useState(null);
    const [ phone, setPhone ] = useState(null);
    const [ email, setEmail ] = useState(null);
    const [ tos, setTos ] = useState(false);
    const [ agreeToSMS, setAgreeToSMS ] = useState(true);

    useEffect(() => {
        if (appointment !== null) {
            setFirstName(appointment.customer_first_name);
            setLastName(appointment.customer_last_name);
            setPhone(appointment.customer_phone);
            setEmail(appointment.customer_email);
            setTos(true)
            setAgreeToSMS(appointment.agree_to_sms)
        }
    }, [ appointment ])

    const getContent = () => {
        return (<>
            <div className={ style.inputRow }>
                <Input required={ true } type="text" label="First Name" value={ firstName } onValueChange={ setFirstName } />
                <Input required={ true } type="text" label="Last Name" value={ lastName } onValueChange={ setLastName } />
            </div>
            <div className={ style.formGroup }>
                <Input required={ true } type="phone" label="Phone" value={ phone } onValueChange={ setPhone } />
            </div>
            <div className={ style.formGroup }>
                <Input required={ true } type="email" label="Email" value={ email } onValueChange={ setEmail } />
            </div>

            <section style={ {
                padding: '10px 0'
            } }>
                <h4 style={ { margin: 0 } }>Terms for booking an Appointment</h4>
                <p style={ { margin: 0, fontSize: '15px', lineHeight: '25px', opacity: 0.8 } }>Please stay available by phone and updated by email, changes or cancellations are possible. You can change an appointment via email. (Do not order a new appointment before the previous one is canceled). Please notify in advance of cancellation of an appointment (up to two hours in advance), a customer who does not cancel in the system and / or notifies the clinic will be charged in full. There is no late appointment, a delay of more than 5 minutes allows the clinic to receive another client and you will also be charged at full price.</p>

                <div className={ style.inputGroup }>
                    <Input required={ true } value={ tos } type="checkbox" label="I have read the above terms & agree to them" onValueChange={ setTos } />
                </div>

                {
                    /*
                    <div className={ style.inputGroup }>
                        <Input required={ false } value={ agreeToSMS } type="checkbox" label="I would like to receive an SMS reminder before my appointment." onValueChange={ setAgreeToSMS } />
                    </div>
                    */
                }
            </section>
        </>)
    }

    const isFinished = () => {
        return firstName?.length > 0 && lastName?.length > 0 && phone?.length > 0 && email?.length > 0 && tos
    }

    const getSummary = () => {
        return (
            <>
                { firstName } { lastName } / { phone } / { email }
            </>
        )
    }

    const getData = () => {
        return {
            firstName,
            lastName,
            phone,
            email,
            tos,
            agreeToSMS
        }
    }

    const submit = async () => {
        const data = {
            clinic_id: clinic.id,
            service_id: payload.service && payload.service.id ? payload.service.id : null,
            service_options: payload.service_options,
            staff_id: payload.staff,
            customer_first_name: firstName,
            customer_last_name: lastName,
            customer_phone: phone,
            customer_email: email,
            agree_to_sms: agreeToSMS,
            tos: tos,
            scheduled_at: payload.date
        }

        return await api.post('/booking', data);

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(data)
            }, 30000)
        })
    }

    return (
        <StepSkeleton title="Personal Details" number={ number } show={ show } complete={ complete } getContent={ getContent } getSummary={ getSummary } getData={ getData } submit={ submit } canContinue={ isFinished } continueLabel={ "Book my Appointment" } isCompleted={ appointment !== null ? true : undefined } />
    )
}

export default PersonalDetails;